// extracted by mini-css-extract-plugin
export default {"btn":"profileButton_btn__banPE"};